import { getScrollY } from './scrollPosition';

const $window: JQuery<Window> = $(window);
let lastScrollTop: number = -1;

const scrollListener = {
  start() {
    this.check();
  },

  check() {
    const scrollTop: number = getScrollY();

    if (lastScrollTop !== scrollTop) {
      lastScrollTop = scrollTop;
      $window.trigger('scroll:virtual', lastScrollTop);
    }

    requestAnimationFrame(this.check.bind(this));
  },
};

export default scrollListener;
